module.exports = window["MaterialUI"].Drawer;